import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

export default {
    mixins: [abstractValidatorMixin],
    data() {
        return {
            serverErrors: {
                name: [],
                date: []
            }
        };
    },
    validations: {
        formData: {
            name: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(255)
            },
            date: { required }
        }
    },
    computed: {
        nameErrors() {
            return this.checkErrors('name');
        },
        dateErrors() {
            return this.checkErrors('date');
        }
    }
};
